import {sweetAPI} from 'app/store/sweet-api';
import {modelSubscriptionRegistry} from 'app/subscriptions/subscriptionRegistry';

import type {StoreType} from 'app/store/AppStore';
import type {ModelChangeMessageType} from 'app/subscriptions';

export function handleModelUpdate(
  event: string,
  {data}: {data: ModelChangeMessageType},
  sendMessage: unknown,
  store: StoreType
) {
  // invalidate that model tag on rtk-query sweetAPI
  // so any mounted component using the sweetAPI to fetch that model list will refetch it
  // https://redux-toolkit.js.org/rtk-query/usage/automated-refetching
  store.dispatch(
    sweetAPI.util.invalidateTags(
      // @ts-expect-error we inject tags on the API after it's created so TS doesn't know bout them
      [{type: data.model, id: 'list'}].concat(
        // if an model ID was provided, invalidate that specific object as well (for detail pages)
        // @ts-expect-error same as above
        'id' in data ? [{type: data.model, id: data.id}] : []
      )
    )
  );
  return modelSubscriptionRegistry.process(data);
}
